<template>
  <div
    class="data-board-s"
    :style="{
      border: isLayoutSet ? '1px dashed #2587FF' : '1px solid #d9d9d9',
    }"
  >
    <div class="title">
      <div>
        <eui-icon icon="eicon-wuliuzhongxin" color="#333" font-size="18px" />
        <span class="text">物流中心</span>
      </div>
    </div>

    <!-- { id: 1, name: '未回复' },
          { id: 2, name: '已回复' }, -->
    <div class="tabs-container">
      <div class="epxpress-route">
        <expressFastRoute></expressFastRoute>
      </div>
      <div class="express-center-wrap">
        <div class="order-left">
          <div class="title">销售订单</div>
          <el-tabs
            v-model="saleActive"
            class="tabs-area"
            @tab-click="handleSaleClick"
          >
            <el-tab-pane label="未发货" name="0">
              <div slot="label">
                <el-badge
                  :value="supplierCount.waitShipCount"
                  :max="99"
                  class="item"
                >
                  <span size="small" style="padding: 0 20px">未发货</span>
                </el-badge>
              </div>
            </el-tab-pane>
            <el-tab-pane label="待收货" name="2">
              <div slot="label">
                <el-badge
                  :value="supplierCount.receiveCount"
                  :max="99"
                  class="item"
                >
                  <span size="small" style="padding: 0 20px">待收货</span>
                </el-badge>
              </div>
            </el-tab-pane>
            <el-tab-pane label="收货完成" name="1">
              <div slot="label">
                <el-badge
                  :value="supplierCount.receiveCompletedCount"
                  :max="99"
                  class="item"
                >
                  <span size="small" style="padding: 0 20px">收货完成</span>
                </el-badge>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div class="message-content">
            <div class="order-info-wrap">
              <ul>
                <li v-for="item in showSupplierListOrder" :key="item.orderId">
                  <div class="top top-1">
                    <span class="order-no">订单编号：{{ item.orderNo }}</span>
                    <span class="order-date"
                      >下单时间：{{ item.submitTime }}</span
                    >
                  </div>
                  <div class="top">
                    <span class="order-company"
                      >采购商：{{ item.purchaseCompany }}</span
                    >
                    <eui-btn
                      v-if="saleActive === '0'"
                      type="link"
                      size="20"
                      @click="goToExpress(item, 'DELIEVER')"
                      >操作</eui-btn
                    >
                    <eui-btn
                      v-else
                      type="link"
                      size="20"
                      @click="goToExpress(item, 'EXPRESS')"
                      >查看物流</eui-btn
                    >
                  </div>
                </li>
                <li class="order-more">
                  <eui-btn
                    v-if="showSupplierListOrder.length > 2"
                    type="link"
                    icon="eicon-arrow-right"
                    @click="goToExpress('/orderManage', 'MORE')"
                    >更多</eui-btn
                  >
                </li>
              </ul>
            </div>
            <div v-if="messages.length === 0" class="empty">暂无订单</div>
          </div>
        </div>
        <div class="order-left">
          <div class="title">采购订单</div>
          <el-tabs
            v-model="purchaserActive"
            class="tabs-area"
            @tab-click="handlePurchaseClick"
          >
            <el-tab-pane label="全部留言" name="0">
              <div slot="label">
                <el-badge
                  :value="purchaseCount.waitShipCount"
                  :max="99"
                  class="item"
                >
                  <span size="small" style="padding: 0 20px">未发货</span>
                </el-badge>
              </div>
            </el-tab-pane>
            <el-tab-pane label="已回复" name="2">
              <div slot="label">
                <el-badge
                  :value="purchaseCount.receiveCount"
                  :max="99"
                  class="item"
                >
                  <span size="small" style="padding: 0 20px">待收货</span>
                </el-badge>
              </div>
            </el-tab-pane>
            <el-tab-pane label="未回复" name="1">
              <div slot="label">
                <el-badge
                  :value="purchaseCount.receiveCompletedCount"
                  :max="99"
                  class="item"
                >
                  <span size="small" style="padding: 0 20px">收货完成</span>
                </el-badge>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div class="message-content">
            <div class="order-info-wrap">
              <ul>
                <li v-for="item in showPurchaseListOrder" :key="item.orderId">
                  <div class="top top-1">
                    <span class="order-no">订单编号：{{ item.orderNo }}</span>
                    <span class="order-date"
                      >下单时间：{{ item.submitTime }}</span
                    >
                  </div>
                  <div class="top">
                    <span class="order-company"
                      >供应商：{{ item.supplierCompany }}</span
                    >
                    <eui-btn
                      type="link"
                      size="20"
                      @click="goToUrl(item, 'SINGLE')"
                      >操作</eui-btn
                    >
                    <!-- <eui-btn
                      v-if="purchaserActive === '0'"
                      type="link"
                      size="20"
                      >操作</eui-btn
                    > -->
                    <!-- <eui-btn v-else type="link" size="20">查看物流</eui-btn> -->
                  </div>
                </li>
                <li class="order-more">
                  <eui-btn
                    v-if="showPurchaseListOrder.length > 2"
                    type="link"
                    icon="eicon-arrow-right"
                    @click="goToUrl(item, 'ALL')"
                    >更多</eui-btn
                  >
                </li>
              </ul>
            </div>
            <div v-if="messages.length === 0" class="empty">暂无订单</div>
          </div>
        </div>
      </div>
    </div>
    <messageBoardDialog
      :visible="visible"
      :set-visible="setVisible"
      :current="current"
      :refresh="getListHandle"
    />
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/home/index'; // queryPageForCompany
import MessageBoardDialog from './messageBoard/index.vue';
import expressFastRoute from './expressFastRoute.vue';
import { purchaseUrl } from '../../../../api/config';

export default {
  components: { MessageBoardDialog, expressFastRoute },
  props: {
    isLayoutSet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listQuery: {
        pageNum: 1,
        pageSize: 4,
        status: '',
      },
      visible: false,
      current: {},
      total: 20,
      messages: [],
      saleActive: '0',
      purchaserActive: '0',
      purchaseCount: {},
      supplierCount: {},
      purchaseListOrder: [],
      supplierListOrder: [],
    };
  },
  computed: {
    showPurchaseListOrder() {
      return this.purchaseListOrder.length > 0
        ? this.purchaseListOrder.splice(0, 3)
        : [];
    },
    showSupplierListOrder() {
      return this.supplierListOrder.length > 0
        ? this.supplierListOrder.splice(0, 3)
        : [];
    },
  },
  watch: {
    quickNavActive(newVal) {
      if (newVal === '0') {
        this.listQuery.status = '';
      } else {
        this.listQuery.status = newVal;
      }
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
  },
  mounted() {
    this.getList(this.listQuery);
    this.getOrderCount({});
    // 获取默认的采购订单
    this.getPurchaseListOrder([17, 18, 12, 32, 21]);
    // 获取默认的采购订单
    this.getSupplierListOrder([17, 18, 12, 32, 21]);
  },
  methods: {
    // 获取订单数量
    async getOrderCount(params) {
      const res = await Api.logisticsCenterCountOrder(params);
      if (res?.code === '200') {
        this.purchaseCount = res.data.purchaseCount;
        this.supplierCount = res.data.supplierCount;
      }
    },
    // 获取采购订单列表
    async getPurchaseListOrder(status) {
      const res = await Api.purchaseListOrder({ orderStatusList: status });
      if (res?.code === '200') {
        this.purchaseListOrder = res.data.records;
      }
    },
    // 获取销售订单列表
    async getSupplierListOrder(status) {
      const res = await Api.supplierListOrder({ orderStatusList: status });
      if (res?.code === '200') {
        this.supplierListOrder = res.data.records;
      }
    },

    // 销售订单切换
    handleSaleClick() {
      console.log(this.saleActive);
      let status = [];
      if (this.saleActive === '0') {
        status = [17, 18, 12, 32, 21];
      }
      if (this.saleActive === '2') {
        status = [4];
      }
      if (this.saleActive === '1') {
        status = [6, 22, 102, 103];
      }
      this.getSupplierListOrder(status);
    },
    handlePurchaseClick() {
      let status = [];
      if (this.purchaserActive === '0') {
        status = [17, 18, 12, 32, 21];
      }
      if (this.purchaserActive === '2') {
        status = [4];
      }
      if (this.purchaserActive === '1') {
        status = [6, 22, 102, 103];
      }
      this.getPurchaseListOrder(status);
    },
    getListHandle() {
      this.getList(this.listQuery);
    },
    openMessage(row) {
      this.current = row;
      this.setVisible(true);
    },
    async getList(params) {
      const result = await Api.queryPageForCompany(params);
      if (result.code === '200') {
        this.messages = [...result.data.records];
      }
      this.total = result.data?.total || 0;
    },

    handleDelete(id) {
      Api.deleteMessage({ id }).then((res) => {
        if (res.code === '200') {
          this.$message.success({ message: '删除成功', duration: 1500 });
          this.getList(this.listQuery);
        }
      });
    },
    setVisible(bool) {
      this.visible = bool;
    },
    goToExpress(item, type) {
      console.log(23);
      if (type === 'EXPRESS') {
        this.$router.push({
          path: '/invoiceListDetail',
          query: {
            orderId: item.orderId,
            purchaseCompanyId: item.purchaseCompanyId,
            orderNo: item.orderNo,
            isOnLinePay: item.isOnLinePay,
          },
        });
      }
      if (type === 'MORE') {
        this.$router.push({
          path: '/orderManage',
        });
      }
      if (type === 'DELIEVER') {
        this.$router.push({
          path: '/orderManage',
          query: {
            orderNo: item.orderNo,
            // purchaseCompanyId: item.purchaseCompanyId,
            // isOnLinePay: item.isOnLinePay,
            from: 'workbench',
          },
        });
      }
    },
    goToUrl(item, type) {
      if (type === 'ALL') {
        window.open(`${purchaseUrl}/user/user/userOrder`, '_blank');
      } else {
        window.open(
          `${purchaseUrl}/user/user/userOrder?from=workbench&orderNo=${item.orderNo}`,
          '_blank'
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.title {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f5f5;
  height: 44px;
  padding: 0 20px;
  color: #333;
  .text {
    margin-left: 10px;
  }
  .more {
    color: #333;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: normal;
    &:hover {
      color: #0064c8;
    }
  }
}
.data-board-s {
  width: 100%;
  margin-top: 20px;
  .tabs-container {
    padding: 20px 20px 10px 20px;
    background: #fff;
  }
  ::v-deep .el-tabs--card {
    & > .el-tabs__header {
      margin-bottom: 5px;
      .el-tabs__nav {
        border: none;
      }
      .el-tabs__item {
        border: 1px solid #d9d9d9;
        border-left: 0;
        &:first-child {
          border-left: 1px solid #d9d9d9;
        }
      }
      .el-tabs__item.is-active {
        background: #f4f7ff;
        position: relative;
        color: #0064c8;
        &:first-child {
          border-left: 0;
          border-bottom: 0;
        }
        &:last-child {
          border-right: 0;
          border-bottom: 0;
        }
        &::before {
          content: '';
          display: block;
          position: absolute;
          top: -1px;
          left: 0;
          right: 0;
          border-top: 2px solid #0064c8;
        }
      }
    }
  }
  .message-content {
    padding: 0 10px;
    .empty {
      height: 70px;
      color: #bbb;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .order-info-wrap {
      li:not(:last-child) {
        border-bottom: 1px solid #dcdcdc;
        padding: 10px 0;
        cursor: pointer;
        &:hover {
          background: #f4f7ff;
        }
      }
      .top {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        &.top-1 {
          margin-bottom: 10px;
        }
      }
      .order-no {
        font-size: 14px;
        color: #333;
        font-weight: 500;
        line-height: 1;
      }
      .order-date,
      .order-company {
        font-size: 12px;
        color: #666666;
        line-height: 1;
      }
      .order-more {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
        margin-bottom: 15px;
      }
    }
  }

  .express-center-wrap {
    display: flex;
    justify-content: space-between;
    // & > div {
    //   margin-right: 20px;
    // }
    .order-left {
      &:first-child {
        margin-right: 20px;
      }
      width: 50%;
      border: 1px solid #d9d9d9;
      .title {
        background: #f5f5f5;
        height: 44px;
        line-height: 44px;
        font-size: 14px;
        color: #333;
        margin-bottom: 20px;
        padding: 0 10px;
      }
    }
  }
  .tabs-area ::v-deep .el-badge__content.is-fixed {
    top: 10px;
    right: 20px;
  }
}
</style>
